export default __webpack_public_path__ + "static/media/facebook_privacy_es.5d2644ff.svg";